export default __webpack_public_path__ + "static/media/panchovilla.b65108b9.jpeg";